import React, { Component, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Logo from "../../../assets/notifylog.png";
import api from "../../../services/api";
import { login } from "../../../services/auth";

import { Form, Container } from "./styles";

const ForgotPass = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");


  const handleSignIn = async (e) => {
    e.preventDefault();
    const { email, password } = this.state;
    if (!email || !password) {
      this.setState({ error: "Preencha e-mail e senha para continuar!" });
    } else {
      try {
        const response = await api.post("/sessions", { email, password });
        login(response.data.token);
        this.props.navigate("/app"); // Usando navigate do hook
      } catch (err) {
        this.setState({
          error:
            "Houve um problema com o login, verifique suas credenciais. T.T",
        });
      }
    }
  };

  return (
    <Container>
      <Form onSubmit={handleSignIn}>
        <img src={Logo} alt="Notify" />
        <h1>Você esqueceu a senha?</h1>
        <p>
          Basta digitar o seu endereço de e-mail abaixo para receber instruções
          de recuperação.
        </p>
        {error && <p>{error}</p>}

        <div className="mb-1">
          <input
            type="email"
            className="form-control w-100"
            id="exampleFormControlInput1"
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value ) }
          />
        </div>

        <button type="submit" className="w-100">
          Recuperar a minha senha
        </button>
        <hr />
      </Form>
    </Container>
  );
};

export default ForgotPass;
